define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ProductModel = /** @class */ (function () {
        function ProductModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.Description = ko.observable();
            this.UnitCost = ko.observable();
            this.Quantity = ko.observable();
            this.Inventory = ko.observable();
            this.ProductType = ko.observable();
            this.CategoryId = ko.observable();
            this.CategoryName = ko.observable();
            this.SupplierId = ko.observable();
            this.SupplierName = ko.observable();
            this.Tax1Id = ko.observable();
            this.Tax1Name = ko.observable();
            this.Tax2Id = ko.observable();
            this.Tax2Name = ko.observable();
            if (data) {
                var self_1 = this;
                ko.mapping.fromJS(data, ProductModel.Mapping, self_1);
            }
        }
        ProductModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ProductModel(options.data);
            }
        };
        return ProductModel;
    }());
    return ProductModel;
});
//# sourceMappingURL=ProductModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ProductModel.js
// module id = 294
// module chunks = 2